import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { favorites, useLocalList } from "@/lib/storage";
import PropertyCard from "@/components/PropertyCard";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Heart } from "@phosphor-icons/react";

export default function Favorites() {
  const ids = useLocalList(favorites);
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!ids.length) { setItems([]); return; }
    Promise.all(ids.map((id) => api.get(`/listings/${id}`).then((r) => r.data).catch(() => null)))
      .then((r) => setItems(r.filter(Boolean)));
  }, [ids.join(",")]);

  return (
    <div data-testid="favorites-page">
      <SEO title="Favourites" description="Your saved Dubai properties on Point Penta." path="/favorites" noIndex />
      <section className="pt-6 pb-6 border-b border-neutral-200">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Favourites", path: "/favorites" }]} />
          <div className="overline text-[#001588] mb-4">Favourites</div>
          <h1 className="font-serif text-5xl lg:text-6xl leading-tight">Your shortlist.</h1>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          {items.length === 0 ? (
            <div className="border border-neutral-200 p-16 text-center text-neutral-500" data-testid="favorites-empty">
              <Heart size={28} className="mx-auto mb-4 text-neutral-300" />
              You haven't saved any properties yet.
              <div className="mt-4"><Link to="/properties" className="text-[#001588] hover:text-white">Browse mandates →</Link></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
              {items.map((p) => <PropertyCard key={p.id} p={p} />)}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
